import { ORDER_AGGREGATORS_QUOTATION_REQUEST } from "constants/action-types";

export const downloadQuotation = (voucherNum, deliveryNum, name) => {
  return {
    type: ORDER_AGGREGATORS_QUOTATION_REQUEST,
    payload: {
      request: {
        url: "selling/order-aggregators/quotation",
        method: "GET",
        responseType: "blob",
        headers: {
          'Cache-Control': 'no-cache',
        },
        params: {
          voucherNum,
          deliveryNum,
          name
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/orderAggregators/quotation.js